import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import $ from "jquery";
import axios from 'axios';

class AdminNavbar extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

componentDidMount(){

}

menuSelections(list_name){
	this.props.open_menu_page(list_name);
}
logoutUser(){
  let cutThis = this;
  var web_token = $('#web_token').val();
   var body = new FormData();
   body.append('web_token',web_token);
   body.append('function','logout_session');
   var url      = '';
   if(window.location.host ==="localhost:3000"){
     url = "http://localhost/bylawsindia/php/logout_utl.php";
   }else{
     url = "/php/logout_utl.php";
   }
   axios({
        method: 'POST',
        url: url,
        data: body
    })
    .then(function (res) {
      var data = res.data;
      if(data==1){
        window.location.href = '/';
      }
    })
    .catch(function (error) {
        console.log(error);
    });
}

  render() {
    return (


        <div className="col-md-2 dbg-light d-md-block sidebar p-0" id="dashboard_left_menu_card">
        		<div className="col-md-12 dashboard-logo-div"><img className="img-fluid flex-shrink-0 menu-logo" src="/assets/img/logo1.png"/></div>
                <div className="left-sidebar">
                    <ul className="nav flex-column sidebar-nav">
                        <li className="nav-item">
                            <a className="nav-link nav_link_p" id="calendar" onClick={() => this.menuSelections('calendar')}>Calendar</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link nav_link_p" id="schedule_consultation" onClick={() => this.menuSelections('schedule_consultation')}>Schedule Consultation</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link nav_link_p" id="free_consultation" onClick={() => this.menuSelections('free_consultation')}>Free Consultation</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link nav_link_p" id="all_clients" onClick={() => this.menuSelections('all_clients')}>Clients</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link nav_link_p" id="addUser" onClick={() => this.menuSelections('addUser')}>Employee</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link nav_link_p" id="view_part_time_employee" onClick={() => this.menuSelections('view_part_time_employee')}>Part-Time Employee</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link nav_link_p" id="view_event" onClick={() => this.menuSelections('view_event')}>Event Management</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link nav_link_p" id="view_leave" onClick={() => this.menuSelections('view_leave')}>Leave Management</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link nav_link_p" id="view_holiday" onClick={() => this.menuSelections('view_holiday')}>Holiday Management</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link nav_link_p" id="view_profile" onClick={() => this.menuSelections('view_profile')}>Profile</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link nav_link_p" id="" onClick={() => this.logoutUser()}>Logout</a>
                        </li>
                    </ul>
                </div>
            </div>

    );
  }
}

export default AdminNavbar;
